import toast, { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useEffect, useState } from "react";
import axios from "axios";
import { API_URL, baseurl } from "../../_config";
import DataTable from "react-data-table-component";

const Venues = () => {
    const [error, setError] = useState();
    const [slotData, setSlotData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isFormopen, setIsFormopen] = useState(false);
    const [slotId, setSlotId] = useState(0);
    const [formData, setFormData] = useState({
        slotId: 0,
        slot: "",
        quantity: "",
        slotdate: ''
    });

    const fetchslotData = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getslotdetail}`);
            if (response.status === 200) {
                setSlotData(response?.data?.data)
            }
        } catch (error) {
            setError("Error fetching menu data:", error);
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchslotData();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${baseurl}${API_URL?.saveSlot}`, formData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 200) {
                toast.success("Save Successfully");
                setIsFormopen(false);
                fetchslotData();
                setSlotId(0)
                setFormData({
                    slotId: 0,
                    slot: "",
                    quantity: "",
                    slotdate: ''
                });
            }
        } catch (error) {
            toast.error("Please try again later.");
        }
    };

    const onEdit = (item) => {
        setSlotId(item?.SlotId)
        setIsFormopen(true);
        setFormData({
            ...formData,
            slotId: item?.SlotId,
            slot: item?.Slot,
            quantity: item?.Quantity,
            slotdate: item?.slotdate
        });
    }

    const handleDelete = async (slotId) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this slot?");

        if (isConfirmed) {
            try {
                const response = await axios.post(`${baseurl}${API_URL?.deleteSlotById}`, {
                    slotId: slotId
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                if (response.status === 200) {
                    toast.success("Slot Deleted Successfully");
                    fetchslotData();
                }
            } catch (error) {
                toast.error("Please try again later.");
            }
        }
    };

    const onClose = () => {
        setIsFormopen(false);
        setSlotId(0)
        setFormData({
            slotId: 0,
            slot: "",
            quantity: "",
            slotdate: ''
        });
    }

    const columns = [
        {
            name: 'SR.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
        },
        {
            name: 'Slot Time',
            selector: row => row.Slot,
            sortable: true,
            minWidth: '120px'
        },
        {
            name: 'Quantity',
            selector: row => row.Quantity,
            sortable: true,
            minWidth: '100px'
        },
        {
            name: 'Created Date',
            selector: row => {
                if (row.SlotDate) {
                    const date = new Date(row.SlotDate);

                    const indianTime = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

                    const day = String(indianTime.getDate()).padStart(2, '0');
                    const month = String(indianTime.getMonth() + 1).padStart(2, '0');
                    const year = indianTime.getFullYear();

                    return `${day}/${month}/${year}`;
                } else {
                    return 'N/A';
                }
            },
            sortable: false,
            minWidth: '180px'
        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span onClick={() => onEdit(row)} title='Edit' className='edit_icon_wepper'>
                        <svg id="Layer_1" viewBox="0 0 512 512" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z" fill="#ff7722" />
                                <path d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z" fill="#ff7722" />
                                <defs>
                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#526484" />
                                        <stop offset="100%" stopColor="#0063ff" />
                                    </linearGradient>
                                </defs>
                            </g>
                        </svg>
                    </span>
                    <span onClick={() => handleDelete(row?.SlotId)} title='Delete' className="delete_icon_weepr">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
            sortable: false
        }
    ];
    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Venues</h4>
                    </div>
                    <div className="d-md-flex align-items-end justify-content-end" style={{ gap: "20px" }}>
                        <div className="add_btn">
                            <button onClick={() => setIsFormopen(true)}>Add Slot</button>
                        </div>
                    </div>
                </div>
                {error ? (
                    <p>Data not avaiable</p>
                ) : (
                    <div className="datatable mt-4">
                        <DataTable
                            columns={columns}
                            data={slotData || []}
                            progressPending={loading}
                            progressComponent={<p>Loading...</p>}
                            pagination
                            highlightOnHover
                        />
                    </div>
                )}
                <div id="entryformContainer" className={`adminform entryform ${isFormopen ? 'open' : ''}`}>
                    <div className="closebtn">
                        <button className="" onClick={onClose} >
                            <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                                <g transform="matrix(1,0,0,1,0,0)">
                                    <g id="Layer_x0020_1">
                                        <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                        <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>
                    <div className="enForm">
                        <div className="text-center form-heading">
                            <h4>Add Slot</h4>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="slot">Slot {`(e.g.12:00 AM)`}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="slot"
                                    name="slot"
                                    value={formData.slot}
                                    onChange={handleInputChange}
                                    placeholder="Enter Slot"
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="quantity">Quantity</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="quantity"
                                    name="quantity"
                                    value={formData.quantity}
                                    onChange={handleInputChange}
                                    placeholder="Enter Quantity"
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="exampleFormControlInput1">Slot Date</label>
                                <input type="date" className="form-control" id="slotdate" name="slotdate" placeholder="slotdate" value={formData.slotdate ? formData.slotdate : ''} onChange={handleInputChange} required />
                            </div>

                            <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                                <div className="submit-btn pt-2">
                                    <button type="submit">
                                        {slotId !== 0 && slotId !== null ? 'Update' : 'Submit'}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </Layout>
    );
}

export default Venues;